var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"grower-ready-list",attrs:{"screenConfig":_vm.screenConfig,"setLoading":_vm.isLoading,"persistence-key":"cracking-run-grower-ready"}})
}
var staticRenderFns = []

export { render, staticRenderFns }